export const businessEmail = "xiecheng1@3975.com"
export const businessList = [
     {
        name: "千游商务小杰",
        qq: "594843422",
        phone: "19852886295",
        mailbox: "shihaojie@jyqianyou.com",
    },
    {
        name: "千游商务小高",
        qq: "602371286",
        phone: "13771792738",
        mailbox: "gaoqiang@jyqianyou.com",
    },
    
   
    {
        name: "千游商务小马",
        qq: "289456176",
        phone: "13373607397",
        mailbox: "malin@qianyouqn.com",
    },
    {
        name: "千游商务小五",
        qq: "594241",
        phone: "15010805655",
        mailbox: "hanbin@qianyouqn.com",
    },
]